export default __webpack_public_path__ + "static/media/agrishop.f99b7b79.png";